import { TYPES } from '../render/constants';
import { Action } from './action';

function condition() {
  return true;
}

export const internalBadges = [
  {
    value: 'default',
    label: 'badge_black',
    src: 'asset://badge_black',
    size: {
      w: 108,
      h: 30,
    },
    url: '/images/badges/seede-black.svg',
  },
  {
    value: 'badge_white',
    label: 'badge_white',
    src: 'asset://badge_white',
    background: 'black',
    size: {
      w: 108,
      h: 30,
    },
    url: '/images/badges/seede-white.svg',
  },
  {
    value: 'badge1',
    label: 'Default',
    src: 'asset://badge1',
    isChinese: true,
    size: {
      w: 190,
      h: 34,
    },
    url: '/images/badges/seede-label.svg',
  },
  {
    value: 'badge2',
    label: 'Minimal',
    src: 'asset://badge2',
    isChinese: true,
    size: {
      w: 206,
      h: 34,
    },
    url: '/images/badges/seede-label2.svg',
  },
  {
    value: 'badge_en',
    label: 'badge_en',
    src: 'asset://badge_en',
    size: {
      w: 217,
      h: 34,
    },
    url: '/images/badges/seede-badge.svg',
  },
];

export function addSeedeBadge(stageContext, type = 'default') {
  const nodes = stageContext.api.getNodes().filter((node) => node.isSeedeBadge);
  nodes.forEach((node) => {
    stageContext.api.removeNode(node.id, true);
  });
  const frames = stageContext.api.getFrames();
  const badge = internalBadges.find((badge) => badge.value === type);
  if (badge) {
    frames.forEach((frame) => {
      addOrUpdateBadge(stageContext, frame, badge);
    });
  }
}

function addOrUpdateBadge(stageContext, frame, badge) {
  const size = badge.size;
  const padding = 32;
  stageContext.api.addNode({
    type: TYPES.image,
    name: 'Seede Badge',
    badgeType: badge.value,
    isSeedeBadge: true,
    parentId: frame.id,
    locked: true,
    x: frame.w - size.w - padding,
    y: frame.h - size.h - padding,
    w: size.w,
    h: size.h,
    src: badge.src,
  });
}

export const addSeedeBadgeAction = new Action({
  name: 'addBadge',
  handler: addSeedeBadge,
  condition: condition,
});
